import {
  Autocomplete as MUIAutocomplete,
  AutocompleteProps as MUIAutocompleteProps,
  TextField,
  TextFieldProps,
} from "@/common/styles/style";

interface CustomAutocompleteProps<T>
  extends Omit<MUIAutocompleteProps<T, true, false, false>, "renderInput"> {
  label?: string;
  placeholder?: string;
  textProps?: TextFieldProps
}

export default function Autocomplete<T>({
  label,
  placeholder,
  textProps,
  ...props
}: CustomAutocompleteProps<T>) {
  return (
    <MUIAutocomplete
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textProps}
          // variant="filled"
          label={label}
          placeholder={placeholder}
        />
      )}
    />
  );
}
